import { ChangeDetectorRef, Component, Inject, Input, NgZone, OnInit, ViewRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LpsConversionDetails } from 'src/app/models/lps-conversion-details';
import { CommonUtils } from 'src/app/utils/common-utils';

interface DialogInputData {
  sourceType: string;
  filename: string;
}

interface SpectrumVersion {
  value: string;
  label: string;
}

@Component({
  selector: 'convert-dialog',
  templateUrl: './convert-dialog.component.html',
  styleUrls: ['./convert-dialog.component.css']
})
export class ConvertDialogComponent implements OnInit  {
  static readonly DEFAULT_SPECTRUM_VERSION: SpectrumVersion = { value: '5.1', label: '5.1' };

  spectrumVersions: SpectrumVersion[] = [
    ConvertDialogComponent.DEFAULT_SPECTRUM_VERSION,
  ];
  @Input() supportGLM = false;
  @Input() showAdditionalProperties = false;

  public displayAdvancedOptions: boolean = false;
  protected advancedOptionsValid: boolean = true;

  public displayConversionDetails: boolean = true;
  protected conversionDetailsValid: boolean = false;

  protected conversionDetails: LpsConversionDetails;

  public ngOnInit(): void {
    this.conversionDetails = new LpsConversionDetails();
    this.conversionDetails._migrationType = this.inputData.sourceType;
    this.conversionDetails.filename = this.inputData.filename;
    this.conversionDetails.targetVersion = ConvertDialogComponent.DEFAULT_SPECTRUM_VERSION.value;
  }

  constructor(
    public dialogRef: MatDialogRef<ConvertDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public inputData: DialogInputData, 
    private cdr: ChangeDetectorRef, 
    private ngZone: NgZone) { }

  // Send the cancel message if the cancel button is closed
  onCancel() {
    this.dialogRef.close('cancel');
  }

  onConvert() {
    this.dialogRef.close(this.conversionDetails)
  }

  public showAdvancedOptions() {
    this.displayAdvancedOptions = true;
    this.displayConversionDetails = false;
  }

  public showConversionDetails() {
    this.displayAdvancedOptions = false;
    this.displayConversionDetails = true;
  }

  public convertDisabled(): boolean {
    return (!this.conversionDetails.targetVersion || !this.advancedOptionsValid || !this.conversionDetailsValid);
  }

  public advancedOptionsValidationHandler(isValid: boolean) {
    this.advancedOptionsValid = isValid;
  }

  public conversionDetailsValidationHandler(isValid: boolean) {
    this.conversionDetailsValid = isValid;
  }

   protected detectChanges(delay: boolean = false) { 
      if (delay === true) {
        CommonUtils.lwDelay(this, this.ngZone, () => { this.detectChanges(); })
      } else {
        if (this.cdr && !((this.cdr as ViewRef).destroyed)) { this.cdr.detectChanges(); }
      }
    }

}